import { render, staticRenderFns } from "./OrgLoginsModal.vue?vue&type=template&id=dd7e758e"
import script from "./OrgLoginsModal.vue?vue&type=script&lang=js"
export * from "./OrgLoginsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports